export default "__VITE_ASSET__DrcWVJQ___"